import getSettingsImport from '../../settings'
import { selectors as backendSelectors, constants as backendConstants } from '../Backend'
import { actions as creativeActions } from '../Creatives'
import { actions as newsActions } from '../News'
import { actions as toasterActions } from '../Toaster'
import { actionLoggerLog } from '../../actions'

export const getSettings = (locale) => {
    const settings = getSettingsImport(locale)
    return {
        versionRegex: settings.attributes.regex.version,
        enabled: settings.sync.enabled,
        timer: {
            interval_seconds: settings.sync.timer.interval_seconds,
            delay_minutes: settings.sync.timer.delay_minutes,
            multiplier: settings.sync.timer.multiplier,
        },
        fallback: {
            overwriteBackground: settings.sync.fallback.overwriteBackground,
            background: settings.sync.fallback.background,
        },
        url: {
            hash: settings.sync.url.hash,
            sync: settings.sync.url.sync,
        },
    }
}

export const constants = {
    SERVERLIST_CHANGED: backendConstants.SERVERLIST_CHANGED,
}

export const actions = {
    creativesOutdated: creativeActions.outdated,
    newsOutdated: newsActions.outdated,
    motdOutdated: toasterActions.motdOutdated,
    log: actionLoggerLog,
}

export const selectors = {
    getLocale: state => backendSelectors.getLocale(state),
    getServers: state => backendSelectors.getServers(state),
    getLauncherType: state => backendSelectors.getLauncherType(state),
}



// WEBPACK FOOTER //
// ./src/features/Sync/imports.js